// import React from 'react';
// import "./SportOneW18Events.scss";
// import { useNavigate } from "react-router-dom";

// const SportOneW18Events = () => {
//     const navigate = useNavigate();
//     return (
//         <section className="sport-one-W18-pass-section sport-one-fade-section">
//             <div className="w18pass-heading">
//                 <h2>W18 Events</h2>
//                 <a href="/products?category=W18-Events" className="learn-more">MORE EVENTS</a>
//             </div>
//             <br />
//             {/* <div className="cards-container">

//                 <div className="card">
//                     <img src="/assets/img/sports/sport-one/images/bdm2.jpg" alt="W18 Event" />
//                     <div className="card-content">
//                         <h6 className="event-title">Brighter Minds | W18 Internal Academy Badminton Tournament 2025</h6>
//                         <div className="event-info">
//                             <div className="info-item">
//                                 <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                     <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
//                                 </svg>
//                                 <span>W18 SPORTS UNIVERSE</span>
//                             </div>
//                             <div className="info-item">
//                                 <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                     <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
//                                 </svg>
//                                 <span>W18 SPORTS UNIVERSE</span>
//                             </div>
//                             <div className="info-item">
//                                 <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                     <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-1.99.9-1.99 2L3 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H5V8h14v13z" />
//                                 </svg>
//                                 <span>Fri, 16 May 2025</span>
//                             </div>
//                         </div>
//                         <div className="card-buttons">
//                             <button className="btn-secondary">₹ PRICE</button>
//                             <button className="btn-primary">MORE EVENTS</button>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card">
//                     <img src="/assets/img/sports/sport-one/images/bdm3.jpg" alt="W18 pass Pro" />
//                     <h6 className="event-title"> <span className="pro">W18 SPORTS UNIVERSE | LITTLE CHAMPS-STARTER(BATCH:1 2)</span></h6>
//                     <ul>
//                         <li>Organiser Name: W18 SPORTS UNIVERSE</li>
//                         <li>Venue:W18 SPORTS UNIVERSE </li>
//                         <li>Date:Fri, 23 May 2025</li>
//                     </ul>
//                     <div className="card-buttons">
//                         <button className="btn-secondary">PRICE</button>
//                         <button className="btn-primary">MORE EVENTS</button>
//                     </div>
//                 </div>

//                 <div className="card">
//                     <img src="/assets/img/sports/sport-one/images/bdm4.jpg" alt="W18 Event" />
//                     <div className="card-content">
//                         <h6 className="event-title">Brighter Minds | W18 Internal Academy Badminton Tournament 2025</h6>

//                         <div className="event-info">
//                             <div className="info-item">
//                                 <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                     <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//                                 </svg>
//                                 <span>W18 SPORTS UNIVERSE</span>
//                             </div>
//                             <div className="info-item">
//                                 <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                     <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//                                 </svg>
//                                 <span>Fri, 16 May 2025</span>
//                             </div>
//                         </div>

//                         <div className="card-buttons">
//                             <button className="btn-secondary">₹ PRICE</button>
//                             <button className="btn-primary">MORE EVENTS</button>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="card">
//                     <img src="/assets/img/sports/sport-one/images/bdm5.jpg" alt="W18 pass Select" />
//                     <h6 className="event-title"> <span className="select">VSMASH 2.0</span></h6>
//                     <ul>
//                         <li>Organiser Name:  Veritas Software Technologies India Private Limited</li>
//                         <li>Venue:W18 SPORTS UNIVERSE, PANCARD CLUB ROAD, BANER, PUNE</li>
//                         <li>Date:Fri, 23 May 2025</li>
//                     </ul>
//                     <div className="card-buttons">
//                         <button className="btn-secondary">PRICE</button>
//                         <button className="btn-primary">MORE EVENTS</button>
//                     </div>
//                 </div>
//             </div> */}
//             <div className="cards-container">

// <div className="card">
//   <img src="/assets/img/sports/sport-one/images/training11.jpg" alt="W18 Event" />
//   <div className="card-content">
//     <h6 className="event-title">Brighter Minds | W18 Internal Academy Badminton Tournament 2025</h6>
//     <div className="event-info">
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//         </svg>
//         <span>W18 SPORTS UNIVERSE</span>
//       </div>
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//         </svg>
//         <span>Fri, 16 May 2025</span>
//       </div>
//     </div>
//     <div className="card-buttons">
//       <button className="btn-secondary">₹ PRICE</button>
//       <button className="btn-primary">MORE EVENTS</button>
//     </div>
//   </div>
// </div>

// <div className="card">
//   <img src="/assets/img/sports/sport-one/images/training8.jpg" alt="W18 Event" />
//   <div className="card-content">
//     <h6 className="event-title">W18 SPORTS UNIVERSE | LITTLE CHAMPS-STARTER(BATCH:1 2)</h6>
//     <div className="event-info">
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//         </svg>
//         <span>W18 SPORTS UNIVERSE</span>
//       </div>
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//         </svg>
//         <span>Fri, 23 May 2025</span>
//       </div>
//     </div>
//     <div className="card-buttons">
//       <button className="btn-secondary">₹ PRICE</button>
//       <button className="btn-primary">MORE EVENTS</button>
//     </div>
//   </div>
// </div>

// <div className="card">
//   <img src="/assets/img/sports/sport-one/images/training15.jpg" alt="W18 Event" />
//   <div className="card-content">
//     <h6 className="event-title">W18 SHUTTLE PRO- BADMINTON PLAYERS TROPHY-2025</h6>
//     <div className="event-info">
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//         </svg>
//         <span>W18 SPORTS UNIVERSE, PANCARD CLUB ROAD, BANER, PUNE</span>
//       </div>
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//         </svg>
//         <span>Fri, 30 May 2025</span>
//       </div>
//     </div>
//     <div className="card-buttons">
//       <button className="btn-secondary">₹ PRICE</button>
//       <button className="btn-primary">MORE EVENTS</button>
//     </div>
//   </div>
// </div>

// <div className="card">
//   <img src="/assets/img/sports/sport-one/images/workout3.jpg" alt="W18 Event" />
//   <div className="card-content">
//     <h6 className="event-title">VSMASH 2.0</h6>
//     <div className="event-info">
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//         </svg>
//         <span>Veritas Software Technologies India Private Limited</span>
//       </div>
//       <div className="info-item">
//         <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//           <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//         </svg>
//         <span>Fri, 23 May 2025</span>
//       </div>
//     </div>
//     <div className="card-buttons">
//       <button className="btn-secondary">₹ PRICE</button>
//       <button className="btn-primary">MORE EVENTS</button>
//     </div>
//   </div>
// </div>

// </div>

//             {/* {activeProducts.length > 4 && ( */}
//             <div className="show-more-container">
//                 <button
//                     className="show-more-btn"
//                     onClick={() => navigate("/products?category=W18-Events")}
//                 >
//                     Show More
//                 </button>
//             </div>
//             {/* //   )} */}
//         </section>
//     );
// };

// export default SportOneW18Events;

// import React from 'react';
// import "./SportOneW18Events.scss";
// import { useNavigate } from "react-router-dom";

// const SportOneW18Events = () => {
//     const navigate = useNavigate();
//     return (
//         <section className="sport-one-W18-pass-section sport-one-fade-section">
//             <div className="w18pass-heading">
//                 <h2>W18 Events</h2>
//                 <a href="/products?category=W18-Events" className="learn-more">MORE EVENTS</a>
//             </div>

//             <div className="cards-container">
//                 {[
//                     {
//                         img: "bdm2.jpg",
//                         organizer: "W18 SPORTS UNIVERSE",
//                         title: "Brighter Minds | W18 Internal Academy Badminton Tournament 2025",
//                         venue: "W18 SPORTS UNIVERSE",
//                         date: "Fri, 16 May 2025"
//                     },
//                     {
//                         img: "bdm3.jpg",
//                         organizer: "W18 SPORTS UNIVERSE",
//                         title: "LITTLE CHAMPS-STARTER (BATCH:1 2)",
//                         venue: "W18 SPORTS UNIVERSE",
//                         date: "Fri, 23 May 2025"
//                     },
//                     {
//                         img: "bdm4.jpg",
//                         organizer: "W18 SPORTS UNIVERSE",
//                         title: "W18 SHUTTLE PRO- BADMINTON PLAYERS TROPHY-2025",
//                         venue: "W18 SPORTS UNIVERSE, PANCARD CLUB ROAD, BANER, PUNE",
//                         date: "Fri, 30 May 2025"
//                     },
//                     {
//                         img: "bdm5.jpg",
//                         organizer: "Veritas Software Technologies India Private Limited",
//                         title: "VSMASH 2.0",
//                         venue: "W18 SPORTS UNIVERSE, PANCARD CLUB ROAD, BANER, PUNE",
//                         date: "Fri, 23 May 2025"
//                     }
//                 ].map((event, idx) => (
//                     <div className="card" key={idx}>
//                         <img src={`/assets/img/sports/sport-one/images/${event.img}`} alt={event.title} />
//                         <div className="card-content">
//                             <div className="title-block">
//                                 <h6 className="event-title">{event.title}</h6>
//                                 <small className="organizer-name">by {event.organizer}</small>
//                             </div>

//                             <div className="event-info">
//                                 <div className="info-item">
//                                     <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                         <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//                                     </svg>
//                                     <span>{event.venue}</span>
//                                 </div>
//                                 <div className="info-item">
//                                     <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                         <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//                                     </svg>
//                                     <span>{event.date}</span>
//                                 </div>
//                             </div>

//                             <div className="card-buttons">
//                                 <button className="btn-secondary">₹ PRICE</button>
//                                 <button className="btn-primary">BOOK NOW</button>
//                             </div>
//                         </div>

//                     </div>
//                 ))}
//             </div>

//             <div className="show-more-container">
//                 <button
//                     className="show-more-btn"
//                     onClick={() => navigate("/products?category=W18-Events")}
//                 >
//                     Show More
//                 </button>
//             </div>
//         </section>
//     );
// };

// export default SportOneW18Events;

// import React from 'react';
// import './SportOneW18Events.scss';
// import { useNavigate } from 'react-router-dom';
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';

// const SportOneW18Events = () => {
//     const navigate = useNavigate();
//     const { documents: events, loading } = useCollection('products', ['category', 'array-contains', 'W18-Events']);

//     const filteredEvents = (events || []).filter(
//         (e) => e.status === 'active'
//     );

//     const staticVenue = " BANER, PUNE";
//     const staticDate = "Fri, 23 May 2025";

//     const handleClick = (productId) => {
//         navigate(`/product-details-two/${productId}`);
//     };

//     const renderCard = (event, index) => {
//         return (
//             <div className="card" key={event.id}>
//                 <img
//                     src={event.images?.[0] || '/assets/img/default.jpg'}
//                     alt={event.name}
//                 />
//                 <div className="card-content">
//                     <div className="title-block">
//                         <h6 className="event-title">{event.name}</h6>
//                         <small className="organizer-name">
//                             By {event.short_description?.replace(/^By\s*/i, '')}
//                         </small>
//                     </div>

//                     <div className="event-info">
//                         <div className="info-item">
//                             <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                 <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
//                             </svg>
//                             <span>{staticVenue}</span>
//                         </div>
//                         <div className="info-item">
//                             <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
//                                 <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
//                             </svg>
//                             <span>{staticDate}</span>
//                         </div>
//                     </div>

//                     <div className="card-buttons">
//                         <button className="btn-secondary">₹{event.price || '--'} ONWARDS</button>
//                         <button className="btn-primary" onClick={() => handleClick(event.id)}>BOOK NOW</button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <section className="sport-one-W18-pass-section sport-one-fade-section">
//             <div className="w18pass-heading">
//                 <h2>W18 Events</h2>
//                 {filteredEvents.length > 3 && (
//                     <a href="/products?category=W18-Events" className="learn-more">MORE EVENTS</a>
//                 )}
//             </div>

//             <div className="carousel-wrapper">
//                 <div className="carousel">
//                     {loading ? (
//                         <p>Loading...</p>
//                     ) : (
//                         filteredEvents.map((event, idx) => renderCard(event, idx))
//                     )}
//                 </div>
//             </div>

//         </section>

//     );
// };

// export default SportOneW18Events;

import React from "react";
import "./SportOneW18Events.scss";
import { useNavigate } from "react-router-dom";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const SportOneW18Events = () => {
  const navigate = useNavigate();
  const { documents: events, loading } = useCollection("products", [
    "category",
    "array-contains",
    "W18-Events",
  ]);

  const filteredEvents = (events || []).filter((e) => e.status === "active");
  const maxCardsToShow = filteredEvents.length > 6 ? 6 : filteredEvents.length;

  const eventsToRender = filteredEvents.slice(0, maxCardsToShow);

  const staticVenue = " BANER, PUNE";
  const staticDate = "Fri, 23 May 2025";

  const handleClick = (productId) => {
    navigate(`/product-details-two/${productId}`);
  };

  const renderCard = (event) => (
    <div className="card" key={event.id}>
      <img
        src={event.images?.[0] || "/assets/img/default.jpg"}
        alt={event.name}
      />
      <div className="card-content">
        <div className="title-block">
          <h6 className="event-title">{event.name}</h6>
          <small className="organizer-name">
            By {event.short_description?.replace(/^By\s*/i, "")}
          </small>
        </div>

        <div className="event-info">
          <div className="info-item">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
            </svg>
            <span>{staticVenue}</span>
          </div>
          <div className="info-item">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="#00b894">
              <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 19V8h14v11H5z" />
            </svg>
            <span>{staticDate}</span>
          </div>
        </div>

        <div className="card-buttons">
          <button className="btn-secondary">
            ₹{event.price || "--"} ONWARDS
          </button>
          <button className="btn-primary" onClick={() => handleClick(event.id)}>
            BOOK NOW
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <section className="sport-one-W18-pass-section sport-one-fade-section">
      <div className="w18pass-heading">
        <h2>W18 Events</h2>
        {filteredEvents.length > 6 && (
          <a href="/products?category=W18-Events" className="learn-more">
            MORE EVENTS
          </a>
        )}
      </div>

      <div className="carousel-wrapper">
        <div className="carousel">
          {loading ? (
            <p>Loading...</p>
          ) : (
            eventsToRender.map((event) => renderCard(event))
          )}
        </div>
      </div>
    </section>
  );
};

export default SportOneW18Events;
